export function try_get_querystring_value(name) {
    const query = new URLSearchParams(window.location.search);
    const value = query.get(name);

    if (!value)
        return [false, ""];

    return [true, value];
}

export function querystring_contains(name) {
    const query = new URLSearchParams(window.location.search);
    return query.has(name);
}